import Vue from 'vue';
import VueRouter from 'vue-router';
import store from './store/index.js';
import Unauthorized from './components/Unauthorized.vue';
import AuthWrapper from './components/AuthWrapper.vue';
import Marketplace from './components/marketplace/Marketplace.vue';
import HawkSoftCloud from './components/products/hawkSoftCloud/HawkSoftCloud.vue';
import HawkSoftCloudSuccess from './components/products/hawkSoftCloud/HawkSoftCloudSuccess.vue';
import eSignatureLandingPage from './components/products/eSignature/eSignatureLandingPage.vue';
import AgencyConfirmation from './components/products/eSignature/AgencyConfirmation.vue';
import UserSelection from './components/products/eSignature/UserSelection.vue';
import BillingConfirmation from './components/products/eSignature/BillingConfirmation.vue';
import NextSteps from './components/products/eSignature/NextSteps.vue';
import SeatManagement from './components/products/seatManagement/SeatManagement.vue';
import AgentPortal from './components/products/agentPortal/AgentPortal.vue';
import eSignatureActivation from './components/products/eSignature/Activation/eSignatureActivation.vue';
import Activate from './components/products/eSignature/Activation/Activate.vue';
import BadLink from './components/products/eSignature/Activation/BadLink.vue';
import ExistingEmail from './components/products/eSignature/Activation/ExistingEmail.vue';
import Reactivate from './components/products/eSignature/Activation/Reactivate.vue';
import Expired from './components/products/eSignature/Activation/Expired.vue';
import ESignatureError from './components/products/eSignature/Error.vue';

// Self-Serve Certs
import SelfServeCerts from './components/products/selfServeCerts/SelfServeCerts.vue';
import SelfServeCertsCorporate from './components/products/selfServeCerts/SelfServeCertsCorporate.vue';
import SelfServeCertsSuccess from './components/products/selfServeCerts/SelfServeCertsSuccess.vue';
import SelfServeCertsUnsubscribe from './components/products/selfServeCerts/SelfServeCertsUnsubscribe.vue';

import RegistrationStart from './components/registration/RegistrationStart.vue';
import RegistrationEmail from './components/registration/RegistrationEmail.vue';
import RegistrationUpdate from './components/registration/RegistrationUpdate.vue';
import RegistrationConfirmation from './components/registration/RegistrationConfirmation.vue';
import RegistrationSuccess from './components/registration/RegistrationSuccess.vue';
import RegistrationError from './components/registration/RegistrationError.vue';
import Error from './components/Error.vue';

/* Texting */
import Texting from './components/products/texting/TextingView.vue';
import TextingSetup from './components/products/texting/setup/TextingSetup.vue';
import TextingSetupConf from './components/products/texting/setup/TextingSetupConf.vue';
import TextingSetupMod from './components/products/texting/setup/TextingSetupMod.vue';
import TextingSetupFinish from './components/products/texting/setup/TextingSetupFinish.vue';
import TextingCancel from './components/products/texting/cancel/TextingCancel.vue';
import TextingCancelled from './components/products/texting/cancel/TextingCancelled.vue';

Vue.use(VueRouter);

const Router = new VueRouter({
  scrollBehavior () {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [
    {
      path: '/signin',
      name: 'signin',
      component: require('@/views/auth/Signin.vue').default,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/updatePassword',
      name: 'updatePassword',
      component: require('@/views/auth/UpdatePassword.vue').default,
      meta: {
        requiresAuth: true
      }
    },
    // Legacy
    { path: '/unauthorized', component: Unauthorized },
    { path: '/auth', name: 'sso' },
    { path: '/error', component: Error },
    {
      path: '/eSignatureActivation',
      component: eSignatureActivation,
      children: [
        {
          path: 'Activate',
          name: 'Activate',
          component: Activate
        },
        {
          path: 'BadLink',
          name: 'BadLink',
          component: BadLink
        },
        {
          path: 'ExistingEmail',
          name: 'ExistingEmail',
          component: ExistingEmail
        },
        {
          path: 'Reactivate',
          name: 'Reactivate',
          component: Reactivate
        },
        {
          path: 'Expired',
          name: 'Expired',
          component: Expired
        },
        {
          path: 'Error',
          name: 'Error',
          component: ESignatureError
        }
      ]
    },
    {
      path: '*',
      component: AuthWrapper,
      meta: { requiresAuth: true },
      children: [
        {
          path: '/marketplace',
          name: 'Marketplace',
          component: Marketplace
        },
        {
          path: '/product/',
          redirect: { name: 'Marketplace' }
        },
        {
          path: '/product/hawksoftCloud',
          name: 'HawkSoftCloud',
          component: HawkSoftCloud
        },
        {
          path: '/product/hawksoftCloud/success',
          name: 'HawkSoftCloudSuccess',
          component: HawkSoftCloudSuccess
        },
        {
          path: '/product/texting',
          name: 'Texting',
          component: Texting
        },
        /* Texting Setup routes */
        {
          path: '/product/texting/texting-setup',
          name: 'TextingSetup',
          component: TextingSetup
        },
        {
          path: '/product/texting/texting-setup/configure',
          name: 'TextingSetupConf',
          component: TextingSetupConf
        },
        {
          path: '/product/texting/texting-setup/modify',
          name: 'TextingSetupMod',
          component: TextingSetupMod
        },
        {
          path: '/product/texting/cancel',
          name: 'TextingCancel',
          component: TextingCancel
        },
        {
          path: '/product/texting/cancelled',
          name: 'TextingCancelled',
          component: TextingCancelled
        },
        {
          path: '/product/texting/texting-setup/finish',
          name: 'TextingSetupFinish',
          component: TextingSetupFinish
        },
        /* END Texting Setup routes */
        {
          path: '/product/eSignature',
          name: 'eSignature',
          component: eSignatureLandingPage
        },
        {
          path: '/product/eSignature/agencyConfirmation',
          name: 'AgencyConfirmation',
          component: AgencyConfirmation
        },
        {
          path: '/product/eSignature/userSelection',
          name: 'UserSelection',
          component: UserSelection
        },
        {
          path: '/product/eSignature/billingConfirmation',
          name: 'BillingConfirmation',
          component: BillingConfirmation
        },
        {
          path: '/product/eSignature/nextSteps',
          name: 'NextSteps',
          component: NextSteps
        },
        {
          path: '/product/selfServeCerts',
          name: 'SelfServeCerts',
          component: SelfServeCerts
        },
        {
          path: '/product/selfServeCerts/success',
          name: 'SelfServeCertsSuccess',
          component: SelfServeCertsSuccess
        },
        {
          path: '/product/selfServeCertsCorporate',
          name: 'SelfServeCertsCorporate',
          component: SelfServeCertsCorporate
        },
        {
          path: '/product/selfServeCerts/unsubscribe',
          name: 'SelfServeCertsUnsubscribe',
          component: SelfServeCertsUnsubscribe
        },
        {
          path: '/product/agentPortal',
          name: 'AgentPortal',
          component: AgentPortal
        },
        {
          path: '/seatManagement',
          name: 'SeatManagement',
          component: SeatManagement,
          meta: { seatManagementFeature: true }
        },
        {
          path: '/registration',
          name: 'Registration',
          component: RegistrationStart
        },
        {
          path: '/registration/email',
          name: 'RegistrationEmail',
          component: RegistrationEmail
        },
        {
          path: '/registration/update',
          name: 'RegistrationUpdate',
          component: RegistrationUpdate
        },
        {
          path: '/registration/confirmation',
          name: 'RegistrationConfirmation',
          component: RegistrationConfirmation
        },
        {
          path: '/registration/success',
          name: 'RegistrationSuccess',
          component: RegistrationSuccess
        },
        {
          path: '/registration/error',
          name: 'RegistrationError',
          component: RegistrationError
        }
      ]
    }
  ]
});

if (window.location.hash !== '' && window.location.hash.length > 2) {
  Router.replace({ path: '/' + window.location.hash.substring(2) });
}

Router.beforeEach((to, from, next) => {
  if (from.name === 'sso') {
    next({
      path: '/marketplace',
      replace: true
    });
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    var isAuthenticated = store.state.auth.isAuthenticated;
    if (!isAuthenticated || isAuthenticated === null) {
      next({
        path: '/signin',
        replace: true
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.seatManagementFeature)) {
    if (!store.getters.isSeatManagementEnabled) {
      next({ path: '/marketplace', replace: true });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default Router;
